import ProjImg1 from "../assets/images/Hero_B_02A_copy.jpg"
import ProjImg2 from "../assets/images/Grand_Driveway_Entrance.jpg"
import ProjImg3 from "../assets/images/Arrival_Drop_Off.jpg"
import ProjImg4 from "../assets/images/Party_Deck03A_copy.jpg"
import ProjImg5 from "../assets/images/Pool_Cabanas_04A_copy.jpg"
import ProjImg6 from "../assets/images/Aquatheraphy_Pool.jpg"
import ProjImg7 from "../assets/images/Grill_Pavilion.jpg"
import ProjImg8 from "../assets/images/Function_Rm_1.jpg"
import ProjImg9 from "../assets/images/Cascading_Stream05A_copy.jpg"



export const images = [
  { id:"AMO", title: "AMO Residence, Next To Thomson", subtitle: "Where Life Finds Its Heart..Within, Amongst & Beyond", img: ProjImg1 },  
  { id: "AMO", title: "Grand Driveway Into AMO", subtitle: "Where New Ambience Begins ...", img: ProjImg2 },  
  { id: "Eden", title: "AMO Arrival Court", subtitle: "Arriving In Style ...Everyday", img: ProjImg3 },  
  { title: "Club House & Party Deck", subtitle: "For You & Your Guest...", img: ProjImg4 },
  { title: "Your Pool Cabanas", subtitle: "Amongst The Trees...", img: ProjImg5 },
  { title: "Your Aquatheraphy Pool", subtitle: "Just Dip in & Revitalise...After A long Day", img: ProjImg6 },
  { title: "Your Grill Pavilion", subtitle: "Fine-Dining In AMO-Style...", img: ProjImg7 },
  { title: "Your Function Room", subtitle: "For You & Your VIP Guest...", img: ProjImg8 },
  { title: "Cascading Stream In-Between", subtitle: "For Natural Flow Within...", img: ProjImg9 },
  
  
]
